import axios from 'axios';
const env = window.env;

const HTTP = axios.create({
    baseURL: env.ENHANSA_WORKSPACE_API_URL,
});

//interceptor becasue the store is not yet loaded.
HTTP.interceptors.request.use(
    function (config) {
        config.headers['Accept'] = 'application/json, text/plain';
        var token = localStorage.getItem('accessToken');
        if (token != null) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    function (err) {
        return Promise.reject(err);
    }
);
// Add a response interceptor
HTTP.interceptors.response.use(
    function (response) {
        return {
            data: response.data,
            count: Number(response.headers['x-total-count']),
        };
    },
    function (error) {
        return Promise.reject(error);
    }
);

/*
    Internal functions
    ===
*/
function mapWorkspaceUser({ data, fromServer }) {
    var transformed = {};
    if (fromServer) {
        //from server to local format
        transformed = {
            id: data.userId ? data.userId : data.id,
            workspaceID: data.tenantId,
            roles: data.roles,
            isTenantAdmin: false,
            isCloudAdmin: false,
            profile: JSON.parse(JSON.stringify(data)),
        };
        //check user roles for cloud and tenant admins
        if (transformed.roles && transformed.roles.indexOf('tenant.admin') != -1) {
            transformed.isTenantAdmin = true;
        }
        if (transformed.roles && transformed.roles.indexOf('cloud.admin') != -1) {
            transformed.isCloudAdmin = true;
        }
    } else {
        //from local to server
        transformed = data.profile;
    }
    return transformed;
}

/*
    Exported
    ===
*/
export async function getWorkspaceUser({ userId }) {
    var url = `/api/workspaces/users/${userId}`;
    return HTTP.get(url, {
        transformResponse: (data) => {
            var user = JSON.parse(data);
            return mapWorkspaceUser({ data: user, fromServer: true });
        },
    });
}

export async function getWorkspaceUsers({ page = 0, itemsPerPage = 10, active, userId, workspaceId, searchTerm }) {
    var url = '/api/workspaces/users';

    var searchParams = new URLSearchParams();
    searchParams.append('page', page);
    searchParams.append('size', itemsPerPage);
    if (active) {
        searchParams.append('active', active);
    }
    if (userId) {
        searchParams.append('userId', userId);
    }
    if (workspaceId) {
        searchParams.append('tenantId', workspaceId);
    }
    if (searchTerm) {
        searchParams.append('searchText', searchTerm);
    }

    return HTTP.get(`${url}?${decodeURIComponent(searchParams.toString())}`, {
        transformResponse: (data) => {
            var users = JSON.parse(data);
            if (Array.isArray(users)) {
                return users.map((user) => {
                    return mapWorkspaceUser({ data: user, fromServer: true });
                });
            } else {
                return [];
            }
        },
    });
}

export async function getClientWorkspaceUsers({ page = 0, itemsPerPage = 10, searchTerm }) {
    var url = '/api/clientworkspaces/users';

    var searchParams = new URLSearchParams();
    searchParams.append('page', page);
    searchParams.append('size', itemsPerPage);
    if (searchTerm) {
        searchParams.append('search', searchTerm);
    }

    return HTTP.get(`${url}?${decodeURIComponent(searchParams.toString())}`, {
        transformResponse: (data) => {
            var users = JSON.parse(data);
            return users.map((user) => {
                return mapWorkspaceUser({ data: user, fromServer: true });
            });
        },
    });
}
